<template>
  <div class="add-new-user">
    <h1 class="page-header color-1-100">Create company account</h1>
    <div class="admin-breadcrumbs">
      <router-link class="dashboard background-1-20 color-2-100" to="/">Go to Dashboard</router-link>
      <router-link class="all-users background-1-20 color-2-100" :to="{name: 'companies'}">Back to all companies list</router-link>
    </div>
    <div class="flex-block">
      <div class="content-left-section">
        <div class="content-section content-section__bordered border-1-20 add-user-section no-margin-top" ref="companyDetails">
          <div>
            <div class="add-new-user-form">
              <h3 class="content-section-title color-1-100 background-1-100-before">Add company details</h3>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="new-company-name" class="form-label color-2-63">Company name</label>
                  <input type="text"
                         :class="[{ 'form-control form-control__input background-1-10-disabled  border-1-10-disabled has-error': errors.has('Company name') }, 'form-control form-control__input background-1-10-disabled  border-1-10-disabled']"
                         v-model="newCompany.name"
                         data-lpignore="true"
                         id="new-company-name"
                         v-validate="'required'"
                         name="Company name">
                  <span class="form-field-error" v-if="this.errors.has('Company name')">{{ this.errors.first('Company name') }}</span>
                </div>
                <div class="form-element">
                  <label for="new-company-parent" class="form-label color-2-63">Parent company</label>
                  <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                            :searchable = true
                            v-model="newCompany.parent"
                            :options="preparedCompanies"
                            :clearable="newCompany.parent !== null"
                            data-vv-name="Parent company"
                            data-lpignore="true"
                            :class="[{ 'has-error': errors.has('Parent company') }]"
                            name="Company status"
                            id="new-company-parent" />
                  <span class="form-field-error" v-if="this.errors.has('Parent company')">{{ this.errors.first('Parent company') }}</span>
                </div>
                <div class="form-element">
                  <label for="new-company-industry" class="form-label color-2-63">Industry</label>
                  <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                            :searchable = false
                            v-model="newCompany.industry"
                            :options="getIndustriesForSelect"
                            :clearable="false"
                            data-vv-name="Industry"
                            v-validate="'required'"
                            data-lpignore="true"
                            :class="[{ 'has-error': errors.has('Industry') }]"
                            name="Industry"
                            id="new-company-industry" />
                  <span class="form-field-error" v-if="this.errors.has('Industry')">{{ this.errors.first('Industry') }}</span>
                </div>
                <div class="form-element">
                  <label for="new-company-language" class="form-label color-2-63">Default language</label>
                  <input type="text"
                         class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         disabled="disabled"
                         data-lpignore="true"
                         id="new-company-language"
                         name="Default language"
                         v-model="newCompany.language"/>
                </div>
                <div class="form-element">
                  <label for="new-user-types" class="form-label color-2-63">User types</label>
                  <v-select
                    class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                    :class="[{ 'has-error': errors.has('User types') }]"
                    :searchable=true
                    v-model="newCompany.usersType"
                    :options="getDefaultRegistrationRolesForSelect"
                    data-vv-name="User types"
                    data-lpignore="true"
                    name="User types"
                    id="new-user-types"/>
                  <span class="form-field-error" v-if="this.errors.has('User types')">{{ this.errors.first('User types') }}</span>
                </div>
                <div class="form-element">
                  <label for="companySizes" class="form-label color-2-63">Company size</label>
                  <v-select
                    class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                    :class="[{ 'has-error': errors.has('Company size') }]"
                    :searchable=true
                    v-model="newCompany.companySize"
                    :options="companySizes"
                    data-vv-name="Company size"
                    data-lpignore="true"
                    name="Company size"
                    id="companySizes"/>
                  <span class="form-field-error" v-if="this.errors.has('Company size')">{{ this.errors.first('Company size') }}</span>
                </div>
                <div class="form-element">
                  <label for="companyLocations" class="form-label color-2-63">Company location</label>
                  <v-select
                    class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                    :class="[{ 'has-error': errors.has('Company location') }]"
                    :searchable=true
                    v-model="newCompany.companyLocation"
                    :options="companyLocations"
                    data-vv-name="Company location"
                    data-lpignore="true"
                    name="Company location"
                    id="companyLocations"/>
                  <span class="form-field-error" v-if="this.errors.has('Company location')">{{ this.errors.first('Company location') }}</span>
                </div>
                <div class="form-element">
                  <input type="checkbox" class="form-control form-control__checkbox"
                         data-lpignore="true"
                         :class="[{ 'has-error': errors.has('Sees the Chat box') }]"
                         id="new-company-chat"
                         name="Sees the Chat box"
                         v-model="newCompany.seesChat"/>
                  <label for="new-company-chat" class="form-label color-2-63">Sees the Chat box</label>
                </div>
                <div class="form-element">
                  <input type="checkbox" class="form-control form-control__checkbox"
                         data-lpignore="true"
                         :class="[{ 'has-error': errors.has('Demo company') }]"
                         id="new-company-demo"
                         name="Demo company"
                         v-model="newCompany.isDemo"/>
                  <label for="new-company-demo" class="form-label color-2-63">Demo company</label>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element form-element-date" id="date-selector">
                  <label for="new-company-subscription-end" class="form-label color-2-63">Subscription ends on:</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         data-lpignore="true"
                         id="new-company-subscription-end"
                         name="Subscription ends"
                         @focus="datepicker.shown = true"
                         v-model="newCompany.subscriptionEnd"
                  />
                  <div class="datepicker" v-show="datepicker.shown">
                    <div class="datepicker-calendar-half">
                      <datepicker
                              :inline="true"
                              v-model="datepicker.subscription"
                              @selected="dateSelected($event)"
                              :open-date="datepicker.subscription"
                              :format="'dd/MM/yyyy'"
                      />
                    </div>
                  </div>
                  <span class="form-field-error" v-if="this.errors.has('Subscription ends')">{{ this.errors.first('Subscription ends') }}</span>
                </div>
                <div class="form-element">
                  <label for="new-company-limit" class="form-label color-2-63">Employee limit</label>
                  <input type="text"
                         data-lpignore="true"
                         :class="[{ 'form-control form-control__input background-1-10-disabled  border-1-10-disabled has-error': errors.has('Employee limit') }, 'form-control form-control__input background-1-10-disabled  border-1-10-disabled']"
                         id="new-company-limit"
                         v-validate="'required'"
                         name="Employee limit"
                         v-model="newCompany.employeeLimit"/>
                  <span class="form-field-error" v-if="this.errors.has('Employee limit')">{{ this.errors.first('Employee limit') }}</span>
                </div>
                <div class="form-element">
                  <label for="new-company-status" class="form-label color-2-63">Company status</label>
                  <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                            :searchable = false
                            v-model="newCompany.enabled"
                            :options="getStatusesForSelect"
                            :clearable="newCompany.enabled !== null"
                            data-vv-name="Company status"
                            data-lpignore="true"
                            :class="[{ 'has-error': errors.has('Company status') }]"
                            name="Company status"
                            id="new-company-status" />
                  <span class="form-field-error" v-if="this.errors.has('Company status')">{{ this.errors.first('Company status') }}</span>
                </div>
                <div class="form-element">
                  <label for="company-contraption" class="form-label color-2-63">Company contraption</label>
                  <input type="text"
                         class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         data-lpignore="true"
                         maxlength="4"
                         style="text-transform:uppercase"
                         :class="[{ 'has-error': errors.has('Company contraption') }]"
                         id="company-contraption"
                         name="Company contraption"
                         v-model="newCompany.contraption"/>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="content-section content-section__bordered border-1-20 add-user-section" ref="companyEmails">
          <div>
            <div class="add-new-user-form">
              <h3 class="content-section-title color-1-100 background-1-100-before">Company registration settings</h3>
              <div class="form-group">
                <div class="form-group form-group-half">
                  <div class="form-element">
                    <label for="company-registration" class="form-label color-2-63">Allow user registration</label>
                    <v-select
                      class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                      :searchable=false
                      v-model="newCompany.allowRegistration"
                      :options="yesNoOptionsForSelect"
                      data-vv-name="Allow user registration"
                      data-lpignore="true"
                      :class="[{ 'has-error': errors.has('Allow user registration') }]"
                      name="Allow user registration"
                      id="company-registration" />
                    <span class="form-field-error" v-if="this.errors.has('Allow user registration')">{{ this.errors.first('Allow user registration') }}</span>
                  </div>
                </div>
                <div class="form-group form-group-half" v-if="newCompany.allowRegistration && newCompany.allowRegistration.value">
                  <div class="form-element">
                    <label for="new-company-url" class="form-label color-2-63">Company URL</label>
                    <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           data-lpignore="true"
                           :class="[{ 'has-error': errors.has('Company url') }]"
                           id="new-company-url"
                           name="Company url"
                           v-model="newCompany.url"/>
                  </div>
                </div>
                <div class="form-group form-group-half" v-if="newCompany.allowRegistration && newCompany.allowRegistration.value">
                  <div class="form-element">
                    <label for="company-registration-all-emails" class="form-label color-2-63">Only allow emails from an approved domain</label>
                    <v-select
                      class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                      :searchable=false
                      v-model="newCompany.allowAllEmails"
                      :options="yesNoOptionsForSelect"
                      data-vv-name="Allow all emails"
                      data-lpignore="true"
                      :class="[{ 'has-error': errors.has('Allow all emails') }]"
                      name="Allow all emails"
                      id="company-registration-all-emails" />
                    <span class="form-field-error" v-if="this.errors.has('Allow all emails')">{{ this.errors.first('Allow all emails') }}</span>
                  </div>
                </div>
                <div class="form-group form-group-half" v-if="newCompany.allowRegistration && newCompany.allowRegistration.value">
                  <div class="form-element">
                    <label for="company-registration-need-approval" class="form-label color-2-63">New users must be approved by an admin</label>
                    <v-select
                      class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                      :disabled="newCompany.allowRegistration && newCompany.allowRegistration.value"
                      :searchable=false
                      v-model="newCompany.emailApproval"
                      :options="yesNoOptionsForSelectNew"
                      data-vv-name="Request approval"
                      data-lpignore="true"
                      :class="[{ 'has-error': errors.has('Request approval') }]"
                      name="Request approval"
                      id="company-registration-need-approval" />
                    <span class="form-field-error" v-if="this.errors.has('Allow all emails')">{{ this.errors.first('Request approval') }}</span>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div  v-if="newCompany.allowRegistration && newCompany.allowRegistration.value" >
                <h3 class="content-section-subtitle color-2-63">Approved email domains</h3>
                <div class="form-group">
                  <div class="form-group form-group-half">
                    <div class="form-element">
                      <label class="form-label color-2-63" for="pasteEmails">Bulk paste</label>
                      <textarea data-lpignore="true"
                                class="form-control form-control__textarea"
                                rows="2"
                                id="pasteEmails"
                                cols="20"
                                v-model="emailControl['input']"
                                @paste="emailControl['isPaste'] = true"
                                v-on:blur="createTags($event, false, true)"
                                v-on:input="createTags($event, true)"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div class="form-group form-group-half form-group__email-ending-input"
                     v-for="(row, index) in newCompany.approvedEmails"
                     :class="[{ 'form-group-right-item': (index > 0 && (index + 1) % 2 === 0) }]">
                  <div class="form-element">
                    <input type="text"
                           title="Email"
                           aria-label="Email"
                           class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           v-model="row.email"
                           data-lpignore="true"/>
                  </div>
                  <div class="form-group form-group-half form-group__email-ending-button form-group__email-ending-remove">
                    <div class="add-email-ending" v-on:click="removeElement(index)"></div>
                  </div>
                </div>
                <!--<div class="clearfix"></div>-->
                <div class="form-group form-group-half form-group__email-add-button">
                  <div class="add-email-ending" @click="addEmailRow">Add new</div>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="content-section content-section__bordered border-1-20 add-user-section" ref="companyOwner">
          <div>
            <div class="add-new-user-form">
              <h3 class="content-section-title color-1-100 background-1-100-before">Add account owner contact data</h3>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="owner-first-name" class="form-label color-2-63">First name</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('First name') }]"
                         v-model="ownerData.firstName"
                         data-lpignore="true"
                         id="owner-first-name"
                         name="First name">
                  <span class="form-field-error" v-if="this.errors.has('First name')">{{ this.errors.first('First name') }}</span>
                </div>
                <div class="form-element">
                  <label for="owner-phone" class="form-label color-2-63">Phone number</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Phone number') }]"
                         v-model="ownerData.phoneNumber"
                         data-lpignore="true"
                         id="owner-phone"
                         name="Phone number">
                  <span class="form-field-error" v-if="this.errors.has('Phone number')">{{ this.errors.first('Phone number') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="owner-last-name" class="form-label color-2-63">Last name</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Last name') }]"
                         v-model="ownerData.lastName"
                         data-lpignore="true"
                         id="owner-last-name"
                         name="Last name">
                  <span class="form-field-error" v-if="this.errors.has('Last name')">{{ this.errors.first('Last name') }}</span>
                </div>
                <div class="form-element">
                  <label for="new-user-email" class="form-label color-2-63">Email address</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Email') }]"
                         data-lpignore="true"
                         id="new-user-email"
                         v-validate="'email'"
                         name="Email"
                         v-model="ownerData.email"/>
                  <span class="form-field-error" v-if="this.errors.has('Email')">{{ this.errors.first('Email') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div class="content-right-section anchors">
        <div class="sticky-anchors background-1-40-before">
          <div class="anchor-item color-1-20 details" :class="[{ 'active  color-1-100': activeSection === 'companyDetails' }]">
            <button @click.prevent="goToPageSection('companyDetails')">Add company details </button>
          </div>
          <div class="anchor-item color-1-20 email-endings" :class="[{ 'active  color-1-100': activeSection === 'companyEmails' }]">
            <button @click.prevent="goToPageSection('companyEmails')">Add email endings</button>
          </div>
          <div class="anchor-item color-1-20 owner" :class="[{ 'active  color-1-100': activeSection === 'companyOwner' }]">
            <button @click.prevent="goToPageSection('companyOwner')">Add account owner contact data</button>
          </div>
        </div>
      </div>
    </div>
    <div class="add-new-user-control-panel">
      <button type="button" v-on:click.prevent="discardAllData()" class="clear-form" style="width: 280px;">Cancel, discard all data</button>
      <button type="button" v-on:click.prevent="createNewCompany()" class="submit-user" style="width: 280px;">Create company account</button>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import { mapGetters, mapActions } from 'vuex'
  import AppSelect from '@/components/admin/common/Select'

  export default {
    name: 'add-company',
    data () {
      return {
        infMsgTitle: '',
        infMsgDescription: '',
        infMsgClass: '',
        company: null,
        lastEdited: null,
        newCompany: {
          name: '',
          parent: null,
          industry: null,
          subscriptionEnd: '',
          employeeLimit: '',
          enabled: null,
          url: null,
          language: 'English',
          contraption: '',
          seesChat: true,
          isDemo: false,
          allowRegistration: null,
          allowAllEmails: null,
          emailApproval: null,
          usersType: null,
          companySize: null,
          companyLocation: null,
          approvedEmails: [
            {
              email: ''
            }
          ]
        },
        ownerData: {
          firstName: null,
          lastName: null,
          phoneNumber: null,
          email: null
        },
        serverValidation: {
          errors: []
        },
        disableAPI: false,
        confirmation: {
          action: '',
          isShown: false,
          id: null,
          style: {
            top: '100px'
          }
        },
        datepicker: {
          subscription: null,
          shown: false,
          keepFocus: false
        },
        activeSection: 'companyDetails',
        emailControl: {
          input: '',
          isPaste: false
        }
      }
    },
    computed: {
      ...mapGetters([
        'getIndustriesForSelect',
        'getUserRole',
        'getCompaniesForSelect',
        'getDefaultRegistrationRolesForSelect',
        'companySizes',
        'companyLocations'
      ]),
      getStatusesForSelect () {
        return [
          {
            label: 'Active',
            value: '1'
          },
          {
            label: 'Inactive',
            value: '0'
          }
        ]
      },
      yesNoOptionsForSelect () {
        return [
          {
            label: 'Yes',
            value: true
          },
          {
            label: 'No',
            value: false
          }
        ]
      },
      yesNoOptionsForSelectNew () {
        return [
          {
            label: this.newCompany.allowAllEmails && this.newCompany.allowAllEmails.value ? 'Yes' : 'Yes, all',
            value: true
          },
          {
            label: this.newCompany.allowAllEmails && this.newCompany.allowAllEmails.value ? 'No' : 'Only accounts without an approved domain email',
            value: false
          }
        ]
      },
      preparedCompanies () {
        let companyList = []
        for (let company in this.getCompaniesForSelect) {
          if (this.getCompaniesForSelect[company].parent !== 1) {
            companyList.push(this.getCompaniesForSelect[company])
          }
        }
        return companyList
      }
    },
    methods: {
      ...mapActions([
        'getCompanies',
        'getIndustries',
        'setInformationMsg',
        'getDefaultRegistrationRoles',
        'getCompanySizes',
        'getCompanyLocations'
      ]),
      createNewCompany () {
        this.$validator.validateAll()
        let self = this
        if (this.errors.items.length) return
        let company = {
          companyName: this.newCompany.name,
          parent: this.newCompany.parent,
          industry: this.newCompany.industry,
          subscriptionEnd: this.newCompany.subscriptionEnd,
          employeeLimit: this.newCompany.employeeLimit,
          enabled: this.newCompany.enabled.value,
          ownerFirstName: this.ownerData.firstName,
          ownerLastName: this.ownerData.lastName,
          ownerPhoneNumber: this.ownerData.phoneNumber,
          ownerEmail: this.ownerData.email,
          emailEndings: this.newCompany.approvedEmails,
          url: this.newCompany.url,
          allowRegistration: this.newCompany.allowRegistration ? this.newCompany.allowRegistration.value === true : false,
          allowAllEmails: this.newCompany.allowAllEmails ? this.newCompany.allowAllEmails.value === false : true,
          emailApproval: this.newCompany.emailApproval ? this.newCompany.emailApproval.value === true : false,
          contraption: this.newCompany.contraption,
          seesChat: this.newCompany.seesChat,
          isDemo: this.newCompany.isDemo,
          usersType: this.newCompany.usersType ? this.newCompany.usersType.value : {},
          companySize: this.newCompany.companySize ? this.newCompany.companySize.value : {},
          companyLocation: this.newCompany.companyLocation ? this.newCompany.companyLocation.value : {}
        }
        this.$http.put(api.URLS.companyCreate, company, api.headersAuthSettings)
            .then((res) => {
              this.infMsgTitle = 'A new company called ' + res.body.name + ' was successfully created.'
              this.infMsgDescription = 'Please set the company focus point, start date and the progress before you start adding users.'
              this.infMsgClass = 'success'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              self.goToCompanyList()
            })
            .catch((err) => {
              this.serverValidation.errors = err.body
              this.infMsgTitle = 'Error. We were not able to create this company because '
              for (let error in err.body.error.exception) {
                this.infMsgTitle += err.body.error.exception[error].message + ' '
              }
              this.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.'
              this.infMsgClass = 'error'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
            })
      },
      discardAllData () {
        let self = this
        this.newCompany.name = ''
        this.newCompany.parent = ''
        this.newCompany.industry = ''
        this.newCompany.subscriptionEnd = ''
        this.newCompany.employeeLimit = ''
        this.newCompany.enabled = ''
        this.ownerData.firstName = ''
        this.ownerData.lastName = ''
        this.ownerData.phoneNumber = ''
        this.ownerData.email = ''
        this.newCompany.emailEndings = [{
          email: ''
        }]
        this.newCompany.url = ''
        this.newCompany.allowRegistration = this.yesNoOptionsForSelect[0]
        this.newCompany.allowAllEmails = this.yesNoOptionsForSelect[0]
        this.newCompany.emailApproval = this.yesNoOptionsForSelect[0]
        this.newCompany.contraption = ''
        this.newCompany.seesChat = true
        this.newCompany.isDemo = false
        setTimeout(function () {
          self.errors.clear()
        }, 1)
      },
      createTags (el, wait, blur) {
        const target = this.getTarget(el)
        // const newEmailsSet = {}
        this.emailControl['input'] = target.value
        if (wait && !this.emailControl['isPaste']) {
          this.autoHeight(el)
          return
        }
        if (blur) {
          this.emailControl['isPaste'] = false
          if (this.emailControl['input'] === '') {
            return
          }
        }
        const emails = this.emailControl['input'].split(/(?:,| |>|<|"|'|;)+/)
        for (let index in emails) {
          if (emails[index] !== '') {
            let exists = this.newCompany.approvedEmails.find(item => item.email === emails[index])
            let empty = this.newCompany.approvedEmails.findIndex((item) => item.email === '')
            if (empty !== -1) {
              this.removeElement(empty)
            }
            if (!exists) {
              this.newCompany.approvedEmails.push({
                email: emails[index]
              })
            }
          }
        }
        this.emailControl['isPaste'] = false
        this.emailControl['input'] = ''
        this.addEmailRow()
      },
      autoWidth (el) {
        let target = this.getTarget(el)
        setTimeout(function () {
          if (target) {
            target.style.width = '10px'
            target.style.width = (target.scrollWidth + 15) + 'px'
          }
        }, 0)
      },
      autoHeight (el) {
        let target = this.getTarget(el)
        if (target) {
          setTimeout(function () {
            target.style.height = '40px;'
            target.style.height = (target.scrollHeight + 4) + 'px'
          }, 0)
        }
      },
      getTarget (e) {
        let evn = e || window.event
        return evn.srcElement || e.currentTarget
      },
      closeMsg: function () {
        this.errors.clear()
      },
      addEmailRow: function () {
        this.newCompany.approvedEmails.push({
          email: ''
        })
      },
      removeElement: function (index) {
        this.newCompany.approvedEmails.splice(index, 1)
      },
      dateSelected (e) {
        this.newCompany.subscriptionEnd = this.convertDate(e, '/')
        this.datepicker.shown = false
      },
      convertDate (payload, delimetr) {
        if (!payload) return
        let date = new Date(payload)
        let fullYear = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        function toDoubleDigit (num) {
          return num.toString().length < 2 ? '0' + num : num.toString()
        }
        return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear
      },
      documentClick (e) {
        let self = this
        if (self.datepicker.shown) {
          let datepicker = document.getElementById('date-selector')
          let target = e.target
          if (!this.isDescendant(datepicker, target)) {
            self.datepicker.shown = false
          }
        }
      },
      isDescendant (parent, child) {
        var node = child.parentNode
        while (node !== null) {
          if (node === parent) {
            return true
          }
          node = node.parentNode
        }
        return false
      },
      goToCompanyList () {
        let props = this.$router.resolve({
          name: 'companies'
        })
        this.$router.push(props.href)
      },
      goToPageSection (ref) {
        let element = this.$refs[ref]
        if (element) {
          let here = element[0] ? element[0] : element
          here.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
      },
      posY (elm) {
        let test = elm[0] ? elm[0] : elm
        let top = 0
        if (test && test.tagName) {
          while (test !== null && test.tagName.toLowerCase() !== 'body') {
            top += test.offsetTop
            test = test.offsetParent
          }
        }
        return top
      },
      scrollY () {
        if (window.pageYOffset) {
          return window.pageYOffset
        }
        return Math.max(document.documentElement.scrollTop, document.body.scrollTop)
      },
      isScrolledIntoView (el) {
        let elem = el[0] ? el[0] : el
        let docViewTop = this.scrollY()
        let docViewBottom = docViewTop + window.outerHeight
        let elemTop = this.posY(elem) + 300
        let elemBottom = elemTop + elem.offsetHeight
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop))
      },
      handleScroll () {
        let sections = this.$refs
        for (let index in sections) {
          if (!index.match(/article/)) {
            let section = sections[index]
            if (section && this.isScrolledIntoView(section)) {
              this.activeSection = index
            }
          }
        }
      }
    },
    watch: {
      'newCompany.allowAllEmails' (value) {
        if (value && value.value === false) {
          this.newCompany.emailApproval = this.yesNoOptionsForSelectNew[1]
        }
        if (value && value.value === true) {
          this.newCompany.emailApproval = this.yesNoOptionsForSelect[1]
        }
      },
      'getIndustriesForSelect' (value) {
        if (value) {
          const defaultIndustry = value.find((i) => i.value === 1)
          if (defaultIndustry) {
            this.newCompany.industry = defaultIndustry
          }
        }
      }
    },
    components: {
      AppSelect
    },
    mounted () {
      this.getCompanies()
      this.getIndustries()
      this.getDefaultRegistrationRoles()
      this.getCompanySizes()
      this.getCompanyLocations()
    },
    created () {
      document.onclick = this.documentClick
      window.addEventListener('scroll', this.handleScroll)
      document.title = 'Create company account | Clear Assured'
      this.newCompany.allowRegistration = this.yesNoOptionsForSelect[0]
      this.newCompany.allowAllEmails = this.yesNoOptionsForSelect[0]
      this.newCompany.emailApproval = this.yesNoOptionsForSelect[0]
      this.$store.commit('setUserDimensions')
      if (window._paq) {
        window._paq.push(['setCustomUrl', location.pathname])
        window._paq.push(['setDocumentTitle', document.title])
        window._paq.push(['trackPageView'])
      }
      // if (window.ga) {
      //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
      //   window.ga('send', 'pageview', {
      //     'page': location.pathname,
      //     'location': location.href,
      //     'title': document.title
      //   })
      // }
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style src='@/assets/scss/components/add-user.scss' lang='scss' scoped />



// WEBPACK FOOTER //
// AddCompany.vue?3a18cc88